'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hours;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hours.js
// module id = 680
// module chunks = 0